/**
 * Owner: Masa Bayu
 * File: hub-sample-ceiling.ts
 * Date:Time: 2026-10-28 23:40
 * Description: §510-S2 — bumbung halaman sampel yang diisytiharkan qxp-hub, disimpan
 *   SATU peta untuk SETIAP descriptor katalog. Dahulu cap ini menumpang peta harga
 *   (`hub-sync` hanya mendaftar entri bila `priceMinorUnits` + `currency` ada), jadi
 *   buku tanpa harga tidak mempunyai bumbung dan pembaca jatuh ke lapisan setempat
 *   (lalai 50 halaman = pelawat menentukan had penerbit). Nilai 0 adalah sah dan
 *   ertinya tiada halaman sampel.
 */

const ceilingMap = new Map<string, number>();

/** Gantikan peta bumbung dengan snapshot katalog terkini (panggil sebelum overlay bump). */
export function setHubSampleCeilings(
  entries: Readonly<Record<string, number>>,
): void {
  ceilingMap.clear();
  for (const [publicationId, maxPage] of Object.entries(entries)) {
    ceilingMap.set(publicationId, maxPage);
  }
}

/** Bumbung hub untuk satu publication; `null` = hub tidak mendeklarasi (buku luar talian / id terikat-kod). */
export function getHubSampleCeiling(publicationId: string): number | null {
  return ceilingMap.get(publicationId.trim()) ?? null;
}

/** Ujian sahaja. */
export function __clearHubSampleCeilingsForTests(): void {
  ceilingMap.clear();
}
